import { Metrics } from './metrics';
import { rhumbAggregator } from './rhumbAggregator';
export const timing = {
  timeAttach(duration) {
    Metrics.timer('cpuTime').update(duration);
    rhumbAggregator.accumulate('attach', duration);
  },
  timeDetach(duration) {
    Metrics.timer('cpuTime').update(duration);
    rhumbAggregator.accumulate('detach', duration);
  },
  timeStateChange(duration) {
    Metrics.timer('lifecycleManager.handleStateChange').update(duration);
    Metrics.timer('cpuTime').update(duration);
    rhumbAggregator.accumulate('stateChange', duration);
  },
  timeInvalidate(duration) {
    Metrics.timer('lifecycleManager.invalidate').update(duration);
    Metrics.timer('cpuTime').update(duration);
    rhumbAggregator.accumulate('invalidate', duration);
  },
  timeInvalidateAll(duration) {
    Metrics.timer('lifecycleManager.invalidateAll').update(duration);
    Metrics.timer('cpuTime').update(duration);
    rhumbAggregator.accumulate('invalidate', duration);
  },
  timeCollectNode(duration) {
    Metrics.timer('cpuTime').update(duration);
    rhumbAggregator.accumulate('gc', duration);
  },
  timeResync(duration) {
    Metrics.timer('lifecycleManager.resync').update(duration);
    Metrics.timer('cpuTime').update(duration);
    rhumbAggregator.accumulate('resync', duration);
  }
};